<template>
  <!-- <v-flex> -->
  <svg ref='svgPie' width='200' height='200'></svg>
  <!-- </v-flex> -->
</template>

<script>
const d3 = require('d3')

export default {
  name: 'pie',
  props: ['data', 'color', 'graphicType'],
  mounted: function() {
    this.update(this.data)
    // var svg = d3.select(this.$el)
    // var width = +svg.attr('width')
    // var height = +svg.attr('height')
    // var margin = { top: 20, left: 0, bottom: 30, right: 0 }
    // var chartWidth = width - (margin.left + margin.right)
    // var chartHeight = height - (margin.top + margin.bottom)
    // this.chartLayer = svg
    //   .append('g')
    //   .attr('transform', `translate(${margin.left}, ${margin.top})`)
    // this.arc = d3
    //   .arc()
    //   .outerRadius(chartHeight / 2)
    //   .innerRadius(2)
    //   .padAngle(0.03)
    //   .cornerRadius(0)
    // this.pieG = this.chartLayer
    //   .append('g')
    //   .attr('transform', `translate(${chartWidth / 2}, ${chartHeight / 2})`)
    // this.drawChart(this.data)
  },
  watch: {
    data(newValue, oldValue) {
      // console.log('NEW VALUE: ', newValue)
      // console.log('OLD VALUE: ', oldValue)
      // How to clear the old pie?
      // if (oldValue.length > 0) this.$refs.svgPie.remove()
      // this.drawChart(newValue)
      this.update(newValue)
    }
  },
  methods: {
    update(data) {
      const svgEl = d3.select(this.$el)
      const width = svgEl.attr('width')
      const height = svgEl.attr('height')
      const margin = { top: 0, left: 0, bottom: 0, right: 0 }
      const radius = Math.min(width, height) / 2

      const chartWidth = width - (margin.left + margin.right)
      const chartHeight = height - (margin.top + margin.bottom)

      var svg = svgEl
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .attr('margin', margin)
        .append('g')
        .attr('transform', `translate(${chartWidth / 2}, ${chartHeight / 2})`)

      svg.append('g').attr('class', 'slices')
      var pie = d3.pie()
        .sort(null)
        .value(function(d) {
          return d.value
        })

      var arc = d3.arc()
        .outerRadius(radius * 1.0)
        .innerRadius(radius * 0.5)

      var outerArc = d3.arc()
        .innerRadius(radius * 0.5)
        .outerRadius(radius * 1)

      var key = function(d) { return d.data.label }

      var color = d3.scaleOrdinal()
        .domain(data)
        .range(this.color)
      // var color = d => d3.interpolateCool(Math.random())
      // var color = d3.scaleOrdinal(d3.schemePastel1)
      //   .domain(keys)
      var duration = 300

      var oldData = svg.select('.slices')
        .selectAll('path')
        .data().map(function(d) { return d.data })

      if (oldData.length === 0) oldData = data

      var was = this.mergeWithFirstEqualZero(data, oldData)
      var is = this.mergeWithFirstEqualZero(oldData, data)

      var slice = svg.select('.slices')
        .selectAll('path')
        .data(pie(was), key)

      const colorToSet = []
      const dataRelatedToColor = []
      const colorToSetObj = {}
      slice.enter()
        .insert('path')
        .attr('class', 'slice')
        .style('fill', function(d) {
          const colorToFill = color(d.data.label)
          colorToSet.push(colorToFill)
          return colorToFill
        })
        .style('stroke-opacity', 0.9)
        .style('stroke-width', 1.5)
        .style('stroke', '#424242')
        .each(function(d) {
          dataRelatedToColor.push(d.data)
          this._current = d
        })

      // Return to the parent component the assigned colors
      // related with the label
      colorToSetObj.colors = colorToSet
      colorToSetObj.data = dataRelatedToColor
      colorToSetObj.graphicType = this.graphicType
      this.$emit('set-color', colorToSetObj)

      slice = svg.select('.slices')
        .selectAll('path')
        .data(pie(is), key)

      slice
        .insert('text')
        .attr('dx', 10)
        .attr('dy', -5)
        .style('fill', '#424242')
        .style('font-size', '8px')
        .insert('textPath')
        .attr('xlink:href', function(d, i) {
          return '#arc-' + i
        })
        .text(function(d) {
          return d.data.label
        })

      slice.transition()
        .duration(duration)
        .attrTween('d', function(d) {
          var interpolate = d3.interpolate(this._current, d)
          var _this = this
          return function(t) {
            _this._current = interpolate(t)
            return arc(_this._current)
          }
        })

      slice = svg.select('.slices')
        .selectAll('path')
        .data(pie(data), key)

      slice.exit()
        .transition()
        .delay(duration)
        .duration(0)
        .remove()
    },
    mergeWithFirstEqualZero(first, second) {
      var secondSet = d3.set()

      second.forEach(function(d) { secondSet.add(d.label) })

      var onlyFirst = first
        .filter(function(d) { return !secondSet.has(d.label) })
        .map(function(d) { return {label: d.label, value: 0} })

      var sortedMerge = d3.merge([ second, onlyFirst ])
        .sort(function(a, b) {
          return d3.ascending(a.label, b.label)
        })

      return sortedMerge
    }
    // drawChart: function(data) {
    //   var arcs = d3
    //     .pie()
    //     .sort(null)
    //     .value(function(d) {
    //       return d.value
    //     })(data)

    //   var block = this.pieG.selectAll('.arc').data(arcs)
    //   block.select('path').attr('d', this.arc)

    //   var newBlock = block
    //     .enter()
    //     .append('g')
    //     .classed('arc', true)

    //   newBlock
    //     .append('path')
    //     .attr('d', this.arc)
    //     .attr('id', function(d, i) {
    //       return 'arc-' + i
    //     })
    //     .attr('stroke', 'white')
    //     .attr('fill', d => d3.interpolateCool(Math.random()))

    //   newBlock
    //     .append('text')
    //     .attr('dx', 10)
    //     .attr('dy', -5)
    //     .style('fill', 'white')
    //     .style('font-size', '8px')
    //     .append('textPath')
    //     .attr('xlink:href', function(d, i) {
    //       return '#arc-' + i
    //     })
    //     .text(function(d) {
    //       return d.data.name
    //     })
    // }
  }
}
</script>

<style lang='stylus' scoped></style>


// WEBPACK FOOTER //
// src/components/Pie.vue